import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';

import { PersonalData } from './personal-info-form-columns/personal-data';
import { ContactData } from './personal-info-form-columns/contact-data';
import { SystemData } from './personal-info-form-columns/system-data';
import { EmergencyData } from './personal-info-form-columns/emergency-data';

import { PersonalInfoMainWrapper, StyledWrapper } from '../employee-common.styles';

const PersonalInfo = ({ isEdit, employeeId, isOwnData }: { isEdit?: boolean; employeeId?: string, isOwnData?: boolean }) => {
  const { member } = useGetCurrentMemberAccount();
  return (
    <PersonalInfoMainWrapper>
      <StyledWrapper>
        <PersonalData
          isOwnData={isOwnData}
          employeeId={employeeId}
          isEdit={isEdit}
          profile={{
            gender: member?.profile?.gender,
            birthday: member?.profile?.birthday,
          }}
        />
        <ContactData isOwnData={isOwnData} />
        <SystemData isEdit={isEdit} isOwnData={isOwnData} memberId={member?._id} employeeId={employeeId} />
        <EmergencyData isOwnData={isOwnData} />
      </StyledWrapper>
    </PersonalInfoMainWrapper>
  );
};

export default PersonalInfo;
